module.exports = __webpack_public_path__ + "img/1970East-060_WEB-min.9905426b.jpg";